import React, { useState, useEffect } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { BodyParams, FieldProps, FormDataBase, FormWrapper, onSubmit } from '../common/FormBase'
import { machineIDField } from '../common/fields'

export interface ActivateQRCodeFormData extends FormDataBase {
  machineId: string
}

export interface ActivateQRCodeParams extends BodyParams<ActivateQRCodeFormData>{
  onSubmit: onSubmit<ActivateQRCodeFormData>
}

export const ActivateQRCodeBody = (params: BodyParams<ActivateQRCodeFormData>) => {
  const fieldProps: FieldProps<ActivateQRCodeFormData> = {
    ...params,
    fieldName: ""
  }
  return <>
    {machineId(fieldProps)}
  </>
}

export const ActivateQRCodeForm = (params: ActivateQRCodeParams) => {
  const formHandler: SubmitHandler<ActivateQRCodeFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<ActivateQRCodeFormData> {...params}  formName='activateqrcode' onSubmit={formHandler}>
    <ActivateQRCodeBody {...params} />
  </FormWrapper>
}

export const machineId = (props: FieldProps<ActivateQRCodeFormData>) => machineIDField<ActivateQRCodeFormData>()({...props, fieldName: props.fieldName || "machineId", formName: props.formName || "activateqrcode"})